<template>
    <div class="search-bar-container sticky-top" ref="mainSearchBar" :class="stickyNavTopCssClass" :style="stickyNavTopStyle">
        <template v-if="searchData">
            <div class="content-container" :class="searchBarCssClass" @click.stop>
                <template v-if="uiStore.isMobile">
                    <container v-if="mobileWithNotSearch" @click="showMobileSearch">
                        <row class="gx-0">
                            <column :col="18" class="py-4 px-3 small clickable">
                                Start Your Search
                            </column>
                            <column :col="6" class="d-flex align-items-center justify-content-end pe-3" @click.stop>
                                <badge v-if="hasFilterSearch" color="primary" class="clickable d-flex align-items-center" @click="() => toggle('filters')">
                                    <filters-icon :size="12" />
                                </badge>
                                <filters-icon v-else :size="14" class="clickable" @click="() => toggle('filters')" />

                                <favorites-section class="px-1 ms-3 mb-1" :searchFavorites="favorites" @search="updateFavorites" ref="favoritesButton"/>
                            </column>
                        </row>
                    </container>
                    <container v-else-if="!showMobileFields" @click="showMobileSearch">
                        <row class="gx-0">
                            <column :col="18" class="p-3 small clickable">
                                {{ whereLabel || 'Search Location' }}
                            </column>
                            <column :col="6" class="d-flex align-items-center justify-content-end pe-3" @click.stop>
                                <badge v-if="hasFilterSearch" color="primary" class="clickable d-flex align-items-center" @click="() => toggle('filters')">
                                    <filters-icon :size="12" />
                                </badge>
                                <filters-icon v-else :size="14" class="clickable" @click="() => toggle('filters')" />

                                <favorites-section class="px-1 ms-3 mb-1" :searchFavorites="favorites" @search="updateFavorites" ref="favoritesButton"/>
                            </column>
                            <column v-if="dateRange || whoLabel" class="px-3 pb-3 d-flex align-items-baseline justify-content-between x-small">
                                <div v-if="dateRange" class="d-flex align-items-baseline">
                                    <calendar-icon :size="14" class="text-primary me-2" /> <div class="text-nowrap">{{ dateRange.start.format('n/j/Y') }} - {{ dateRange.end.format('n/j/Y') }}</div>
                                </div>
                                <div v-if="dateRange && whoLabel" class="mx-2 text-muted">|</div>
                                <div v-if="whoLabel" class="text-truncate">
                                    {{ whoLabel }}
                                </div>
                            </column>
                        </row>
                    </container>
                </template>
                <container v-else class="gx-0">
                    <row class="gx-0">
                        <column :col="18" :md="7" :lg="6">
                            <div class="clickable px-3 py-2 py-md-3" :class="whereCssClass" @click="() => toggle('where')" ref="searchFieldElmContainer">
                                <div class="text-uppercase text-primary x-small spaced-letters">Where</div>

                                <form-input v-if="focusOn == 'where'" type="search" :placeholder="whereLabel || 'Search'" class="border-0 bg-body shadow-none px-0" @click.stop v-model="searchKeyword"/>
                                <div v-else class="text-truncate" :class="whereLabel ? null : 'opacity-50 text-muted'">{{ whereLabel || 'Search' }}</div>
                            </div>
                        </column>
                        
                        <column :col="18" :md="9" :lg="9">
                            <div v-if="uiStore.isTablet" class="clickable px-3 py-2 py-md-3" :class="datesCssClass" @click="() => toggle('dates')">

                                <div class="text-uppercase text-primary x-small spaced-letters">When</div>

                                <div v-if="dateRange" class="text-truncate">
                                    {{ dateRange.start.format('n/j/Y') }} - {{ dateRange.end.format('n/j/Y') }}
                                </div>
                                <div v-else-if="startDate" class="text-truncate">
                                    {{ startDate.format('n/j/Y') }}
                                </div>
                                <div v-else class="opacity-50 text-muted text-truncate">
                                    Select Dates
                                </div>
                            </div>
                            <div v-else class="clickable d-flex px-3 py-2 py-md-3" :class="datesCssClass" @click="() => toggle('dates')">
                                <div class="w-50 ">
                                    <div class="text-uppercase text-primary x-small spaced-letters">Arrival</div>
                                    <div v-if="dateRange || startDate" class="text-truncate">
                                        {{ dateRange ? dateRange.start.format('D, n/j/Y') : startDate.format('D, n/j/Y') }}
                                    </div>
                                    <div v-else class="opacity-50 text-muted text-truncate">
                                        mm/dd/yyyy
                                    </div>
                                </div>
                                <div class="w-50">
                                    <div class="text-uppercase text-primary x-small spaced-letters">Departure</div>
                                    <div v-if="dateRange" class="text-truncate">
                                        {{ dateRange.end.format('D, n/j/Y') }}
                                    </div>
                                    <div v-else class="opacity-50 text-muted text-truncate">
                                        mm/dd/yyyy
                                    </div>
                                </div>
                            </div>
                            
                            
                        </column>
                        

                        <column :col="6" :md="5" :lg="5">
                            <div class="clickable px-3 py-2 py-md-3" :class="whoCssClass" @click="() => toggle('who')">
                                <div class="text-uppercase text-primary x-small spaced-letters">Who</div>
                                <div class="text-truncate" :class="whoLabel ? null : 'opacity-50 text-muted'">{{ whoLabel || 'Add Guests' }}</div>
                            </div>
                        </column>
                        <column :col="7" :md="3" :lg="4" class="d-flex align-items-center justify-content-between ps-1">
                            
                            <i v-if="uiStore.isTablet" class="fas fa-sliders-h clickable text-primary" @click="() => toggle('filters')"></i>
                            <ui-button v-else size="sm" color="primary" :outline="true" @click="() => toggle('filters')">
                                Filters
                                <badge v-if="hasFilterSearch" color="primary" class="d-inline-flex align-items-center ms-1">
                                    <filters-icon :size="10" />
                                </badge>
                                <filters-icon v-else :size="12" class="ms-1" />
                            </ui-button>

                            <favorites-section class="px-3 me-lg-2" :searchFavorites="favorites" @search="updateFavorites" ref="favoritesButton"/>
                        </column>
                    </row>
                </container>
            </div>

            <div v-if="uiStore.isMobile" class="position-absolute top-0 start-0 end-0 w-100 search-box" :style="showMobileFields ? 'height: 95svh; overflow:auto' : null" style="touch-action: manipulation" @click.stop>
                <template v-if="showMobileFields">
                    <div class="content-container mb-3" :class="(uiStore.appHeaderFixed || !stickyNavTopStyle) ? `mt-3 ${mobileSearchSectionsCssClass}` : mobileSearchSectionsCssClass" @click="openMobileLocationSearch">
                        <div v-if="focusOn == 'where'" class="py-4 px-3">
                            <form-input  type="search" placeholder="Search Location" class="border-0 bg-body shadow-none p-0" @click.stop v-model="searchKeyword" ref="mobileSearchField"/>
                        </div>
                        <div v-else-if="whereLabel" class="py-4 px-3 d-flex align-items-center justify-content-between small">
                            <span class="x-small text-muted">
                                Where
                            </span>
                            <div>{{ whereLabel }}</div>
                        </div>
                        <div v-else class="py-4 px-3 small">
                            <search-icon :size="16" class="text-primary me-2" /> Search Location
                        </div>

                        <transition name="v-slide-transition-6">
                            <regions-section v-if="focusOn == 'where'" :searchData="searchData" :marketsList="marketsList" :properties="properties" @close="closeMobileSearch" :searchKeyword="searchKeyword" @clear="searchKeyword=null" @click.stop v-model="regionsSearch" />
                        </transition>
                    </div>

                    <div class="content-container mb-3" :class="mobileSearchSectionsCssClass" @click="() => toggle('dates')">
                        <div v-if="dateRange || startDate" class="px-3 d-flex align-items-center justify-content-between small" :class="focusOn == 'dates' ? 'pt-4 pb-3' : 'py-4'">
                            <span class="x-small text-muted">
                                When
                            </span>
                            <div v-if="dateRange" class="text-truncate">
                                {{ dateRange.start.format('n/j/Y') }} - {{ dateRange.end.format('n/j/Y') }}
                            </div>
                            <div v-else-if="startDate" class="text-truncate">
                                {{ startDate.format('n/j/Y') }}
                            </div>
                        </div>
                        <div v-else class="px-3 small d-flex align-items-center" :class="focusOn == 'dates' ? 'pt-4 pb-3' : 'py-4'">
                            <calendar-icon :size="16" class="text-primary me-2" /> <div>Select Dates</div>
                        </div>

                        <transition name="v-slide-transition-6">
                            <div v-if="focusOn == 'dates'" class="px-3 pb-3 x-small" @click.stop>
                                <single-range-calendar v-model="dateRange" :circleWedges="true" startLabel="Arrival" startDateInstructions="Select Arrival Date" endLabel="Departure" endDateInstructions="Select Departure Date" :inline="true" @clear="clearSelectedDate" @selectStart="setStartDate" @selectEnd="closeMobileSearch" :calendarProps="{daysCssClass: 'text-primary'}" min="today" instructionsCssClass="text-muted"  monthButtonSize="sm" monthButtonCssClass="text-primary">
                                    <template #buttons>
                                        <ui-button size="sm" color="primary" :disabled="startDate && !dateRange" @click="closeMobileSearch" class="ms-2">
                                            Apply
                                        </ui-button>
                                    </template>
                                </single-range-calendar>
                            </div>
                        </transition>
                    </div>

                    <div class="content-container mb-3" :class="mobileSearchSectionsCssClass" @click="() => toggle('who')">
                        <div v-if="whoLabel" class="px-3 d-flex align-items-center justify-content-between small" :class="focusOn == 'dates' ? 'pt-4 pb-3' : 'py-4'">
                            <span class="x-small text-muted">
                                Who
                            </span>
                            <div class="text-truncate">
                                {{ whoLabel }}
                            </div>
                        </div>
                        <div v-else class="px-3 small d-flex align-items-center" :class="focusOn == 'dates' ? 'pt-4 pb-3' : 'py-4'">
                            <people-icon :size="16" class="text-primary me-2" /> <div>How many guests or pets?</div>
                        </div>

                        <transition name="v-slide-transition-6">
                            <guests-section v-if="focusOn == 'who'" class="px-3 pb-3 small" @close="closeMobileSearch" @click.stop v-model="guestsSearch" />
                        </transition>
                    </div>

                    <div class="content-container mb-3 p-3 d-flex align-items-center" :class="mobileSearchSectionsCssClass">
                        <div class="small clickable px-3 py-2" @click="mobileFiltersButton">
                            <badge v-if="hasFilterSearch" color="primary" class="d-inline-flex align-items-center me-1">
                                <filters-icon :size="10" />
                            </badge>
                            <filters-icon v-else :size="12" class="me-1" />
                            
                            Additional Filters
                        </div>

                        <div class="small text-muted mx-1">|</div>

                        <favorites-section class="px-3 py-2" :searchFavorites="favorites" @search="updateFavorites" ref="favoritesButton">
                            <div class="small ms-2 d-inline-block">Favorites</div>
                        </favorites-section>
                    </div>

                    <div class="d-flex align-items-center justify-content-between mt-4 px-3">
                        <ui-button size="sm" color="light" @click="clearAll">
                            Clear All
                        </ui-button>
                        <ui-button size="sm" @click="closeSearchBox">
                            <search-icon :size="16" class="me-1" /> Done
                        </ui-button>
                    </div>
                </template>
            </div>
            <div v-else class="position-absolute top-100 start-0 end-0 w-100 search-box" @click="closeSearchBox" style="margin-top:-1px;">
                <transition name="v-slide-transition-6">
                    <div v-if="focusOn == 'dates'" class="content-container bg-body border rounded rounded-3 p-3" :style="uiStore.isMobile ? 'border-top-left-radius: 0px !important;' : null" @click.stop>

                        <single-range-calendar v-model="dateRange" :circleWedges="true" startLabel="Arrival" startDateInstructions="Select Arrival Date" endLabel="Departure" endDateInstructions="Select Departure Date" :inline="true" :numberOfMonths="3" @clear="clearSelectedDate" @selectStart="setStartDate" @selectEnd="closeSearchBox" :calendarProps="{daysCssClass: 'text-primary'}" min="today">
                            <template #buttons>
                                <ui-button size="sm" color="primary" :disabled="startDate && !dateRange" @click="closeSearchBox" class="ms-2">
                                    Apply
                                </ui-button>
                            </template>
                        </single-range-calendar>

                    </div>
                    <div v-else-if="focusOn == 'where'" class="content-container">

                        <regions-section :searchData="searchData" :marketsList="marketsList" :properties="properties" class="bg-body border rounded rounded-3 p-3" style="border-top-left-radius: 0px !important; width:fit-content;" :style="!uiStore.isMobile ? 'margin-left:0.75px;' : null" @close="closeSearchBox" :searchKeyword="searchKeyword" @clear="searchKeyword=null" @click.stop v-model="regionsSearch"  />

                    </div>

                    <div v-else-if="focusOn == 'who'" class="content-container">
                        <container>
                            <row>
                                <column :md="10" :lg="13">&nbsp;</column>
                                <column :md="14" :lg="8">
                                    <guests-section class="bg-body border rounded rounded-3 p-3" @close="closeSearchBox" @click.stop v-model="guestsSearch" />
                                </column>
                            </row>

                        </container>
                    </div>
                        
                </transition>
            </div>
                
        </template>
        <alert v-else-if="error" class="content-container">
            {{ error }}
            <ui-button class="ms-3" @click="requestData">
                Try Again
            </ui-button>
        </alert>

        <transition name="fade-transition-7">
            <div v-if="(focusOn && focusOn != 'filters') || showMobileFields" class="offcanvas-backdrop fade show" @click="closeSearchBox"></div>
        </transition>
        <div v-if="!uiStore.isMobile && focusOn && focusOn != 'filters'" @click="closeSearchBox" class="clickable position-absolute top-0 end-0 close-button d-flex align-items-center justify-content-center bg-info small rounded m-2 text-muted" style="width:22px; height:22px;">
            <i class="fas fa-times"></i>
        </div>

        <marquis-modal v-if="showMarquisModal" @close="showMarquisModal=false"/>

        <modal v-if="focusOn == 'filters'" @close="closeFiltersModal" :open="filtersOpen" size="lg" :closeOnBackgroundClick="true">
            <template #header>
                Filters
            </template>
            <template #default>

                <form-group class="d-flex align-items-center w-100">
                    <div>
                        <div class="small text-muted ms-4 ps-3">Show Only</div>
                        <form-checkbox v-model="marquisLevel" :switch="true" class="form-check-h3">
                            <h3 class="mb-0">Marquis Collection</h3>
                        </form-checkbox>
                    </div>

                    <div class="ms-auto clickable text-center" @click.stop="showMarquisModal=true">
                        <div style="width:38px; height:38px;" class="m-auto">
                            <marquis-circle-icon/>
                        </div>
                        <div class="text-muted xx-small mt-2">
                            Learn More About<br />
                            Marquis Collection Benefits
                        </div>
                    </div>
                </form-group>
                
                <hr class="my-4" />

                <price-section :properties="filteredPropertiesLevel0" :quotes="quotes" :quotesNightly="quotesNightly" class="mb-3" v-model="priceData"/>

                <container>
                    <row>
                        <column :lg="12">
                            <form-group>
                                <form-label>Bedrooms: {{ bedroomsLabel }}</form-label>
                                    <form-duel-range size="lg" :min="bedroomsMinMaxRange.start" :max="bedroomsMinMaxRange.end" v-model="bedroomsRange" class="border-0" :showValues="false">
                                </form-duel-range>
                            </form-group>
                        </column>

                        <column :lg="12">
                            <form-group>
                                <form-label>Bathrooms: {{ bathroomsLabel }}</form-label>
                                    <form-duel-range size="lg" :min="bathroomsMinMaxRange.start" :max="bathroomsMinMaxRange.end" v-model="bathroomsRange" class="border-0" :showValues="false">
                                </form-duel-range>
                            </form-group>
                        </column>

                        <column :lg="12">
                            <form-group>
                                <form-label>Maximum Occupancy: {{ occupancyLabel }}</form-label>
                                    <form-duel-range size="lg" :min="occupancyMinMaxRange.start" :max="occupancyMinMaxRange.end" v-model="occupancyRange" class="border-0" :showValues="false">
                                </form-duel-range>
                            </form-group>
                        </column>

                        <column :lg="12">
                            <form-group>
                                <form-label>Sort By:</form-label>
                                <form-select :options="sortOptions" v-model="sort" placeholder="Featured"/>
                            </form-group>
                        </column>
                    </row>
                </container>

                <hr class="my-4"/>

                <features-section v-model="features" :outdoors="featuresOutdoors" :amenities="featuresAmenities" :locations="featuresLocations" :types="featuresTypes" />
            </template>

            <template #buttons>
                <ui-button size="sm" color="light" @click="clearFilters" class="me-2">
                    Clear
                </ui-button>

                <ui-button size="sm" @click="applyFilters">
                    Apply
                </ui-button>
            </template>
        </modal>
    </div>
    
</template>

<script type="text/javascript">
    import RegionsSection from '@/components/Content/Public/Properties/Search/Sections/Regions.vue';
    import GuestsSection from '@/components/Content/Public/Properties/Search/Sections/Guests.vue';
    import PriceSection from '@/components/Content/Public/Properties/Search/Sections/Price.vue';
    import FeaturesSection from '@/components/Content/Public/Properties/Search/Sections/Features.vue';
    import FavoritesSection from '@/components/Content/Public/Properties/Search/Sections/Favorites.vue';
    import MarquisCircleIcon from '@/assets/logos/marquis-circle-icon.svg.vue';
    import MarquisModal from '@/components/Content/Public/Properties/MarquisModal.vue';

    import SearchIcon from '@/assets/icons/search.svg.vue';
    import PeopleIcon from '@/assets/icons/people.svg.vue';
    import CalendarIcon from '@/assets/icons/calendar.svg.vue';
    import FiltersIcon from '@/assets/icons/filters.svg.vue';

    import CommonComponents from '@/components/Common.vue';

    import Range from '@/classes/Ranges/Range.js';
    import FormOption from '@/classes/FormOption.js';
    import Analytics from '@/classes/Analytics.js';
    import MobileApp from '@/classes/MobileApp.js';
    import ApiConfig from '@/config/api.json';

    import { UseUIStore } from '@/store/UI.js';
    import { UseApiStore } from '@/store/Api.js';

    export default {
        components: {
            RegionsSection,
            GuestsSection,
            PriceSection,
            FeaturesSection,
            FavoritesSection,
            MarquisCircleIcon,
            MarquisModal,

            SearchIcon,
            PeopleIcon,
            CalendarIcon,
            FiltersIcon,

            ...CommonComponents,
        },

        setup() {
            return {
                apiStore: UseApiStore(),
                uiStore: UseUIStore(),
            };
        },

        data() {
            return {
                ready: false,
                error: null,
                disposed: false,
                emptyResults: null,
                requestsTimer: null,

                regionsSearch: null,
                guestsSearch: null,

                startDate: null,

                dateRange: null,
                markets: null,
                cities: null,
                adults: null,
                children: null,
                priceData: null,
                marquisLevel: false,
                bedroomsRange: null,
                bathroomsRange: null,
                occupancyRange: null,
                pets: null,
                features: null,
                favorites: false,
                sort: null,
                profile: null,

                showMobileFields: false,

                focusOn: null,
                focusCssClass: 'border border-bottom-0 rounded-top rounded-top-3 active-field bg-body',
                filtersOpen: true,

                searchKeyword: null,
                showMarquisModal: false,

                sortOptions: FormOption.fromKeyValue({ratings: 'Highest Rating', priceDesc: 'Highest Price', priceAsc:'Lowest Price'}),

                featuresOutdoors: {
                    'o:12': 'Tennis Court',
                    'p:5': 'Private Pool',
                    'p:1': 'Communal Pool',
                    'p:3': 'Hot Tub',
                    'o:33': 'Fenced in Yard',
                    'o:34': 'Fire Pit',
                    'o:38': 'Dock',
                    'o:7': 'BBQ Grill',
                },

                featuresAmenities: {
                    'a:77': 'Kitchen',
                    'a:45': 'Gym/Fitness Room',
                    'a:67': 'Pool Table',
                    'a:46': 'Game Room',
                    'a:74': 'Sauna',
                    'a:2': 'Fireplace',
                    'a:10': 'AC',
                    'a:28': 'Heating',
                },

                featuresLocations: {
                    'o:41': 'Waterfront',
                    'o:40': 'Beachfront',
                    'g:6': 'Lakefront / Pond Front',
                    'a:102': 'Ski-In / Ski-Out',
                },
                
                featuresTypes: {
                    't:3': 'Single Family Home',
                    't:2': 'Condo / Apartment',
                    'g:33': 'Inn',
                    'g:25': 'Bed & Breakfast',
                },
            };
        },

        mounted() {
            document.addEventListener('keyup', this.escapeButton);
        },

        beforeUnmount() {
            clearTimeout(this.requestsTimer);
            this.disposed = true;
            document.removeEventListener('keyup', this.escapeButton);
        },

        emits: ['search', 'ready'],

        props: {
            // the search data model
            modelValue: {
                type: Object,
                default: null,
            },

            // price quotes for dates
            // keyed by property id
            quotes: {
                type: Object,
                default: null,
            },
            quotesNightly: {
                type: Object,
                default: null,
            },
        },

        created() {
            this.setSearchFields();
            if (!this.searchData) {
                this.requestData();
            }
            else {
                this.emitReady();
            }

            this.$watch(
                () => this.modelValue,
                this.setSearchFields,
                { deep: true }
            );
        },

        computed: {
            searchBarCssClass() {
                let cls = [];
                cls.push('bg-body border');

                if (this.uiStore.isMobile) {
                    cls.push('clickable');
                }

                // we need to track the scroll top to track the position
                if (
                    (this.uiStore.appHeaderFixed) ||
                    (
                        (this.uiStore.scrollTop > 0) &&
                        (this.$refs.mainSearchBar) &&
                        (this.$refs.mainSearchBar.getBoundingClientRect().top < 5)
                    )
                ) {
                    cls.push('rounded-bottom rounded-bottom-4 border-top-0');
                }
                else {
                    cls.push('mt-3 rounded rounded-4');
                }

                return cls.join(' ');
            },

            mobileSearchSectionsCssClass() {
                let cls = [];
                cls.push('bg-body border');
                cls.push('clickable');
                cls.push('rounded rounded-4');
                return cls.join(' ');
            },

            stickyNavTopStyle() {
                let top = Math.max(this.uiStore.stickTopNavTop || 0, this.uiStore.visibleHeader || 0);
                
                if (top > 0) {
                    return 'top: '+ top +'px;';
                }
                return null;
            },

            stickyNavTopCssClass() {
                let cls = [];
                if (this.focusOn) {
                    cls.push('focus');
                }
                
                if (cls.length) {
                    return cls.join(' ');
                }
                return null;
            },

            mobileWithNotSearch() {
                if (
                    (this.uiStore.isMobile) &&
                    (!this.showMobileFields) &&
                    (!this.whereLabel) &&
                    (!this.dateRange) &&
                    (!this.whoLabel)
                ) {
                    return true;
                }
                return false;
            },

            requestUrl() {
                let url = this.apiStore.searchDataUrl;
                return url;
            },

            /**
             * IMPORTANT, the properties in this response
             * will have truncated keys
             * e.g. instead of "name", it'll be "n"
             * 'name'                  =>  'n',
             * 'slug'                  =>  'sg',
             * 'city_state_country'    =>  'c',
             * 'market_id'             =>  'mId',
             * 'bedrooms'              =>  'bd',
             * 'bathrooms'             =>  'bt',
             * 'service_level'         =>  'sl',
             * 'max_occupancy'         =>  'oc',
             * 'schedule_price_avg'    =>  'avg',
             * 'public_lat'            =>  'lt',
             * 'public_lng'            =>  'lg',
             * 'pet_policy'            =>  'pt',
             */
            searchData() {
                let response = this.apiStore.requests[this.requestUrl];

                if (!response) {
                    return null;
                }

                if ((response.valid) && (response.results) && (!response.results.error)) {
                    return response.results;
                }
                else {
                    let error = 'Could not complete request';
                    if ((response.results) && (response.results.error)) {
                        if (response.results.error.message) error = response.results.error.message;
                        else error = response.results.error;
                    }
                    this.setError(error);
                }
                
                return null;
            },

            marketsList() {
                if (
                    (this.searchData) &&
                    (this.searchData.markets) &&
                    (this.searchData.markets.length)
                )  {
                    let markets = [];
                    for (let i=0; i<this.searchData.markets.length; i++) {

                        markets.push({
                            name: this.searchData.markets[i].name,
                            id: this.searchData.markets[i].id,
                        });
                    }

                    return markets;
                }

                return null;
            },

            keyedMarketsList() {
                let obj = {};
                if (this.marketsList) {
                    for (let i=0; i<this.marketsList.length; i++) {
                        let id = this.marketsList[i].id;
                        obj[id] = this.marketsList[i];
                    }
                }
                return obj;
            },

            properties() {
                if (
                    (this.searchData) &&
                    (this.searchData.markets) &&
                    (this.searchData.markets.length)
                )  {
                    let properties = [];

                    let blockPropertiesFromSearch = MobileApp.getSessionItem('blockPropertiesFromSearch');
                    if (!blockPropertiesFromSearch) {
                        blockPropertiesFromSearch = [];
                    }
                    
                    for (let i=0; i<this.searchData.markets.length; i++) {

                        for (let j=0; j<this.searchData.markets[i].liveProperties.length; j++) {
                            if (blockPropertiesFromSearch.indexOf(this.searchData.markets[i].liveProperties[j].id) != -1) {
                                continue;
                            }
                            
                            properties.push(this.searchData.markets[i].liveProperties[j]);
                        }
                    }

                    properties.sort(function(a, b) {
                        let aName = a.n.toUpperCase();
                        let bName = b.n.toUpperCase();

                        if (aName < bName) {
                            return -1;
                        }
                        if (aName > bName) {
                            return 1;
                        }
                        return 0;
                    });

                    return properties;
                }

                return null;
            },
            // filtered by region only
            filteredPropertiesLevel0() {
                let re = [];
                if ((this.properties) && (this.properties.length)) {

                    for (let i=0; i<this.properties.length; i++) {

                        // region search
                        if (this.regionsSearch) {
                            if (
                                (this.regionsSearch.markets) &&
                                (this.regionsSearch.markets.length) &&
                                (this.regionsSearch.markets.indexOf(this.properties[i].mId) == -1)
                            ) {
                                continue;
                            }

                            if (
                                (this.regionsSearch.cities) &&
                                (this.regionsSearch.cities.length) &&
                                (this.regionsSearch.cities.indexOf(this.properties[i].c) == -1)
                            ) {
                                continue;
                            }
                        }

                        re.push(this.properties[i]);
                    }
                }
                
                return re;
            },

            // properties filtered by region and quotes
            filteredPropertiesLevel1() {
                let re = [];
                if ((this.filteredPropertiesLevel0) && (this.filteredPropertiesLevel0.length)) {

                    for (let i=0; i<this.filteredPropertiesLevel0.length; i++) {

                        // price range
                        if (this.quotes) {
                            if (!this.quotes[this.filteredPropertiesLevel0[i].id]) {
                                continue;
                            }
                        }
                        else if ((this.priceData) && (this.priceData.priceRange)) {
                            if (this.filteredPropertiesLevel0[i].avg) {
                                let val = Math.round(this.filteredPropertiesLevel0[i].avg);
                                
                                if (!this.priceData.priceRange.inRange(val)) {
                                    continue;
                                }
                            }
                            else {
                                continue;
                            }
                        }

                        re.push(this.filteredPropertiesLevel0[i]);
                    }
                }
                
                return re;
            },

            // properties filtered all search filters
            filteredPropertiesLevel2() {
                let re = [];

                let favIds;
                if ((this.favorites) && (this.$refs.favoritesButton)) {
                    let favProperties = this.$refs.favoritesButton.favoriteProperties();
                    if ((favProperties) && (favProperties.length)) {
                        favIds = {};
                        for (let i=0; i<favProperties.length; i++) {
                            favIds[favProperties[i].propertyId] = true;
                        }
                    }
                }

                if (
                    (this.filteredPropertiesLevel1) &&
                    (this.filteredPropertiesLevel1.length)
                ) {
                    for (let i=0; i<this.filteredPropertiesLevel1.length; i++) {
                        let property = this.filteredPropertiesLevel1[i];

                        if ((favIds) && (!favIds[property.id])) {
                            continue;
                        }

                        // max occupancy and pets
                        if (this.guestsSearch) {
                            
                            let occupants = ((this.guestsSearch.adults || 0) + (this.guestsSearch.children || 0));
                            if (property.oc < occupants) {
                                continue;
                            }
                            
                            // pet policy 3 = not_permitted
                            if ((this.guestsSearch.pets) && (property.pt == 3)) {
                                continue;
                            }
                        }

                        // service level search
                        if ((this.marquisLevel) && (property.sl != 'W')) {
                            continue;
                        }

                        // bedrooms and bathrooms
                        if ((this.bedroomsRange) && (!this.bedroomsRange.inRange(property.bd))) {
                            continue;
                        }

                        if ((this.bathroomsRange) && (!this.bedroomsRange.inRange(property.bt))) {
                            continue;
                        }

                        re.push(property);
                    }
                }
                return re;
            },

            minMaxRanges() {
                let minBedrooms;
                let maxBedrooms;
                let minBathrooms;
                let maxBathrooms;
                let minOccupancy;
                let maxOccupancy;

                for (let i=0; i<this.filteredPropertiesLevel0.length; i++) {
                    if (this.filteredPropertiesLevel0[i].bd != null) {
                        if ((minBedrooms == null) || (minBedrooms > this.filteredPropertiesLevel0[i].bd)) {
                            minBedrooms = this.filteredPropertiesLevel0[i].bd;
                        }
                        if ((maxBedrooms == null) || (maxBedrooms < this.filteredPropertiesLevel0[i].bd)) {
                            maxBedrooms = this.filteredPropertiesLevel0[i].bd;
                        }
                    }

                    if (this.filteredPropertiesLevel0[i].bt != null) {
                        let floorBathrooms = Math.floor(this.filteredPropertiesLevel0[i].bt);
                        let ceilBathrooms = Math.ceil(this.filteredPropertiesLevel0[i].bt);
                        if ((minBathrooms == null) || (minBathrooms > floorBathrooms)) {
                            minBathrooms = floorBathrooms;
                        }
                        if ((maxBathrooms == null) || (maxBathrooms < ceilBathrooms)) {
                            maxBathrooms = ceilBathrooms;
                        }
                    }

                    if (this.filteredPropertiesLevel0[i].oc != null) {
                        if ((minOccupancy == null) || (minOccupancy > this.filteredPropertiesLevel0[i].oc)) {
                            minOccupancy = this.filteredPropertiesLevel0[i].oc;
                        }
                        if ((maxOccupancy == null) || (maxOccupancy < this.filteredPropertiesLevel0[i].oc)) {
                            maxOccupancy = this.filteredPropertiesLevel0[i].oc;
                        }
                    }
                }

                if (minBedrooms == null) minBedrooms = 1;
                if (maxBedrooms == null) maxBedrooms = 12;

                if (minBathrooms == null) minBathrooms = 1;
                if (maxBathrooms == null) maxBathrooms = 5;

                if (minOccupancy == null) minOccupancy = 1;
                if (maxOccupancy == null) maxOccupancy = 16;

                return {
                    bedrooms: new Range(minBedrooms, maxBedrooms),
                    bathrooms: new Range(minBathrooms, maxBathrooms),
                    occupancy:  new Range(minOccupancy, maxOccupancy),
                };
            },

            bedroomsMinMaxRange() {
                let range = this.minMaxRanges.bedrooms.copy();
                if (this.bedroomsRange) {
                    if (range.start > this.bedroomsRange.start) {
                        range.start = this.bedroomsRange.start;
                    }
                    if (range.end < this.bedroomsRange.end) {
                        range.end = this.bedroomsRange.end;
                    }
                }

                range.orient();
                return range;
            },

            bedroomsLabel() {
                if (this.bedroomsRange) {
                    return this.bedroomsRange.start+' - '+this.bedroomsRange.end;
                }
                return this.bedroomsMinMaxRange.start+' - '+this.bedroomsMinMaxRange.end;
            },

            bathroomsMinMaxRange() {
                let range = this.minMaxRanges.bathrooms.copy();
                if (this.bathroomsRange) {
                    if (range.start > this.bathroomsRange.start) {
                        range.start = this.bathroomsRange.start;
                    }
                    if (range.end < this.bathroomsRange.end) {
                        range.end = this.bathroomsRange.end;
                    }
                }

                range.orient();
                return range;
            },

            bathroomsLabel() {
                if (this.bathroomsRange) {
                    return this.bathroomsRange.start+' - '+this.bathroomsRange.end;
                }

                return this.bathroomsMinMaxRange.start+' - '+this.bathroomsMinMaxRange.end;
            },

            occupancyMinMaxRange() {
                let range = this.minMaxRanges.occupancy.copy();
                if (this.occupancyRange) {
                    if (range.start > this.occupancyRange.start) {
                        range.start = this.occupancyRange.start;
                    }
                    if (range.end < this.occupancyRange.end) {
                        range.end = this.occupancyRange.end;
                    }
                }

                range.orient();
                return range;
            },

            occupancyLabel() {
                if (this.occupancyRange) {
                    return this.occupancyRange.start+' - '+this.occupancyRange.end;
                }

                return this.occupancyMinMaxRange.start+' - '+this.occupancyMinMaxRange.end;
            },

            whereLabel() {
                let lblParts = [];

                let markets;
                let cities;

                // for mobile while the search bar is open
                if (this.showMobileFields) {
                    if (this.regionsSearch) {
                        markets = this.regionsSearch.markets;
                        cities = this.regionsSearch.cities;
                    }
                }
                else {
                    markets = this.markets;
                    cities = this.cities;
                }

                if ((markets) && (markets.length)) {

                    if (markets.length == 1) {
                        let market = this.keyedMarketsList[markets[0]];
                        if (market) {
                            lblParts.push(market.name);
                        }
                    }
                    else {
                        lblParts.push(markets.length+' Markets');
                    }
                }
                if ((cities) && (cities.length)) {
                    if (cities.length == 1) {
                        lblParts.push(cities[0]);
                    }
                    else {
                        lblParts.push(cities.length+' towns');
                    }
                }
                if (lblParts.length) {
                    return lblParts.join(' and ');
                }
                return null;
            },

            whereCssClass() {
                let cls = [];
                if (this.uiStore.isMobile) {
                    cls.push('d-flex align-items-center');
                }
                if (this.focusOn == 'where') {
                    cls.push(this.focusCssClass);
                }
                if (cls.length) {
                    return cls.join(' ');
                }
                return null;
            },

            datesCssClass() {
                let cls = [];
                let dFlex = this.uiStore.isMobile;
                if (this.focusOn == 'dates') {
                    cls.push(this.focusCssClass);
                }
                else if ((this.uiStore.isMobile) && (this.focusOn == 'where')) {
                    cls.push('d-none');
                    dFlex = false;
                }
                if (dFlex) {
                    cls.push('d-flex align-items-center');
                }
                
                if (cls.length) {
                    return cls.join(' ');
                }
                return null;
            },

            whoLabel() {
                let lblParts = [];

                let adults;
                let children;
                let pets;

                // for mobile while the search bar is open
                if (this.showMobileFields) {
                    if (this.guestsSearch) {
                        adults = this.guestsSearch.adults;
                        children = this.guestsSearch.children;
                        if (this.guestsSearch.pets) {
                            pets = true;
                        }
                    }
                }
                else {
                    adults = this.adults;
                    children = this.children;
                    pets = this.pets;
                }
                if (adults) {
                    if ((adults == 1) && ((children) || (pets))) {
                        lblParts.push('1 adult');
                    }
                    else if (adults > 1) {
                        lblParts.push(adults+' adults');
                    }
                }
                else if ((children) || (pets)) {
                    lblParts.push('1 adult');
                }
                if (children) {
                    if (children == 1) {
                        lblParts.push('1 child');
                    }
                    else {
                        lblParts.push(children+' children');
                    }
                }
                if (pets) {
                    lblParts.push('pets');
                }
                if (lblParts.length) {
                    if (lblParts.length == 2) {
                        return lblParts.join(' & ');
                    }
                    
                    if (lblParts.length > 1) {
                        lblParts[lblParts.length - 1] = '& '+lblParts[lblParts.length - 1];
                    }
                    return lblParts.join(', ');
                }
                return null;
            },

            whoCssClass() {
                if (this.focusOn == 'who') {
                    if (this.uiStore.isMobile) {
                        return null;
                    }
                    return this.focusCssClass;
                }
                else if ((this.uiStore.isMobile) && (this.focusOn == 'where')) {
                    return 'd-none';
                }
                return null;
            },

            hasFilterSearch() {
                let hasPriceData = false;
                if (
                    (this.priceData) &&
                    (
                        (this.priceData.priceRange) ||
                        (this.priceData.priceRangeType)
                    )
                ) {
                    hasPriceData = true;
                }
                
                if (
                    (hasPriceData) ||
                    (this.marquisLevel) ||
                    (this.bedroomsRange) ||
                    (this.bathroomsRange) ||
                    (this.occupancyRange) ||
                    ((this.features) && (this.features.length))
                ) {
                    return true;
                }
                return false;
            },
        },

        methods: {
            emitSearch() {
                let markets = null;
                let cities = null;

                let event = {};
                if (this.regionsSearch) {
                    markets = this.regionsSearch.markets;
                    cities = this.regionsSearch.cities;

                    if ((markets) && (markets.length)) {
                        let eventMarkets = [];
                        for (let i=0; i<markets.length; i++) {
                            let lbl = markets[i];
                            if (this.keyedMarketsList[lbl]) {
                                lbl = this.keyedMarketsList[lbl].name;
                            }
                            eventMarkets.push(lbl);
                        }
                        event.searchMarkets = eventMarkets;
                    }
                    if ((cities) && (cities.length)) {
                        event.searchCities = cities;
                    }
                }

                let adults = null;
                let children = null;
                let pets = null;
                
                if (this.guestsSearch) {
                    adults = this.guestsSearch.adults;
                    children = this.guestsSearch.children;
                    if (this.guestsSearch.pets) {
                        pets = true;
                    }

                    if (adults) {
                        event.searchAdults = adults;
                    }
                    if (children) {
                        event.searchChildren = children;
                    }
                    if (pets) {
                        event.searchPets = 'yes';
                    }
                }

                let priceRange = null;
                let priceRangeType = null;
                if (this.priceData) {
                    priceRange = this.priceData.priceRange;
                    priceRangeType = this.priceData.priceRangeType;

                    if (priceRange) {
                        event.searchPriceRangeMin = priceRange.start;
                        event.searchPriceRangeMax = priceRange.end;
                    }
                }

                if (this.dateRange) {
                    event.searchCheckIn = this.dateRange.start.format('Y-m-d');
                    event.searchCheckOut = this.dateRange.end.format('Y-m-d');
                }

                if (this.marquisLevel) {
                    event.searchServiceLevel = 'marquis';
                }

                if (this.bedroomsRange) {
                    event.searchBedroomsMin = this.bedroomsRange.start;
                    event.searchBedroomsMax = this.bedroomsRange.end;
                }

                if (this.bathroomsRange) {
                    event.searchBathroomsMin = this.bathroomsRange.start;
                    event.searchBathroomsMax = this.bathroomsRange.end;
                }

                if (this.occupancyRange) {
                    event.searchOccupancyMin = this.occupancyRange.start;
                    event.searchOccupancyMax = this.occupancyRange.end;
                }

                if ((this.features) && (this.features.length)) {
                    event.searchFeatures = this.getFeatureNames(this.features);
                }

                if (this.sort) {
                    event.searchSort = this.sort;
                }

                let data = {
                    dateRange: this.dateRange,
                    markets: markets,
                    cities: cities,
                    adults: adults,
                    children: children,
                    priceRange: priceRange,
                    priceRangeType: priceRangeType,
                    marquisLevel: this.marquisLevel,
                    bedroomsRange: this.bedroomsRange,
                    bathroomsRange: this.bathroomsRange,
                    occupancyRange: this.occupancyRange,
                    pets: pets,
                    features: this.features,
                    favorites: this.favorites,
                    sort: this.sort,
                    profile: this.profile,
                }
                this.$emit('search', data);
                
                if (Object.keys(event).length) {
                    Analytics.event('SearchEvent', event);
                }
            },

            updateFavorites(favs) {
                this.favorites = favs;
                this.emitSearch();
            },

            toggle(section) {
                if (this.focusOn == section) {
                    this.focusOn = null;
                }
                else {
                    this.focusOn = section;
                }

                if (this.focusOn == 'where') {
                    requestAnimationFrame(function() {
                        if (this.$refs.searchFieldElmContainer) {
                            let input = this.$refs.searchFieldElmContainer.querySelector('input');
                            if (input) {
                                input.focus();
                            }
                        }
                    }.bind(this));
                }
                else if (this.focusOn == 'filters') {
                    this.filtersOpen = true;
                }
            },

            setSearchFields() {
                let obj = this.modelValue;
                if (!obj) obj = {};

                let priceData = null;
                if ((obj.priceRange) || (obj.priceRangeType)) {
                    priceData = {
                        priceRange: obj.priceRange,
                        priceRangeType: obj.priceRangeType,
                    }
                }


                this.dateRange = obj.dateRange;
                this.markets = obj.markets;
                this.cities = obj.cities;
                this.adults = obj.adults;
                this.children = obj.children;
                this.priceData = priceData;
                this.marquisLevel = obj.marquisLevel || false;
                this.bedroomsRange = obj.bedroomsRange;
                this.bathroomsRange = obj.bathroomsRange;
                this.occupancyRange = obj.occupancyRange;
                this.pets = obj.pets;
                this.features = obj.features;
                this.favorites = obj.favorites || false;
                this.sort = obj.sort;
                this.profile = obj.profile;

                // reset other data and set related model values
                this.startDate = null;

                this.regionsSearch = {
                    markets: this.markets,
                    cities: this.cities,
                };

                this.guestsSearch = {
                    adults: this.adults,
                    children: this.children,
                    pets: this.pets,
                };


            },

            clearSelectedDate() {
                this.startDate = null;
                this.dateRange = null;
            },

            applyFilters() {
                this.filtersOpen = false;
            },

            clearFilters() {
                this.priceData = null;
                this.marquisLevel = false;
                this.bedroomsRange = null;
                this.bathroomsRange = null;
                this.occupancyRange = null;
                this.features = null;
            },

            setStartDate(date) {
                this.startDate = date;
            },

            async requestData() {
                if (this.disposed) return;
                
                this.setError(null);
                
                clearTimeout(this.requestsTimer);

                let payload = {
                    url: this.requestUrl,
                    staticList: true,
                    keepLive: true,
                };

                await this.apiStore.get(payload);

                this.requestsTimer = setTimeout(this.requestData, ApiConfig.dashboardLongCache * 1000);

                this.emitReady();
            },

            emitReady() {
                if (!this.ready) {
                    this.ready = true;
                    this.$emit('ready');
                }
            },

            setError(error) {
                this.error = error;
            },

            closeMobileSearch() {
                this.focusOn = null;
            },

            clearAll() {
                this.regionsSearch = null;
                this.guestsSearch = null;
                this.priceData = null;
                this.dateRange = null;
                this.startDate = null;
                this.marquisLevel = null;
                this.bedroomsRange = null;
                this.bathroomsRange = null;
                this.occupancyRange = null;
                this.features = null;
                this.favorites = null;
                this.sort = null;
                this.profile = null;
            },

            closeFiltersModal() {
                if (this.showMobileFields) {
                    this.focusOn = null;
                    this.filtersOpen = true;
                    this.uiStore.bodyOverflow(false);
                }
                else {
                    this.closeSearchBox();
                }
            },

            showMobileSearch() {
                this.showMobileFields = true;
                this.uiStore.scrollWindow(150);
                setTimeout(function() {
                    this.uiStore.bodyOverflow(false);
                }.bind(this), 250);
            },

            closeSearchBox() {
                this.focusOn = null;
                this.filtersOpen = true;
                this.showMobileFields = false;
                this.uiStore.bodyOverflow(true);
                setTimeout(function() {
                    this.searchKeyword = null;
                }.bind(this), 250);

                requestAnimationFrame(function() {
                    this.emitSearch();
                }.bind(this));
            },

            mobileFiltersButton() {
                this.focusOn = 'filters';
            },

            escapeButton(evt) {
                if (evt.key == 'Escape') {
                    this.closeSearchBox();
                }
            },

            // called from parent component
            mapProperties() {
                return this.filteredPropertiesLevel2;
            },

            openMobileLocationSearch() {
                this.focusOn = 'where';
                requestAnimationFrame(function() {
                    if (this.$refs.mobileSearchField) {
                        this.$refs.mobileSearchField.focus();
                    }
                }.bind(this));
            },

            getFeatureNames(arr) {
                let re = [];
                if ((arr) && (arr.length)) {
                    let keys = ['featuresOutdoors', 'featuresAmenities', 'featuresLocations', 'featuresTypes'];

                    for (let i=0; i<arr.length; i++) {
                        for (let j=0; j<keys.length; j++) {
                            if (this[keys[j]][arr[i]]) {
                                re.push(this[keys[j]][arr[i]]);
                                break;
                            }
                        }
                    }
                }
                return re;
            },
        },

    };

</script>
